export default {
  prompt: {
    linkpromptLibraries: 'AI-based content generator',
    instructionLibrary: 'Instruction library',
    instructionTitle: 'Title of your instructions',
    defineNewInstruction: 'Define a new instruction',
    defineYourInstructions: 'Define your instructions',
    goBackPostManagement: 'Back to post management',
    textHeader1: 'Unleash your creativity from this page',
    textHeader2: 'Provide instructions to our Artificial Intelligence tool. It will then suggest content for each of your adverts and social network posts that will make you stand out from the crowd. All instructions created will then be available in your library',
    creationPrompt: 'Define your instructions',
    createPrompt: 'Create a prompt',
    cancelCreationPrompt: 'Cancel creation',
    detailsPrompt: 'Prompt details',
    editPrompt: 'Edit prompt',
    deletePrompt: 'Delete the prompt',
    resetPrompt: 'Reset the prompt',
    seeAvailableDataList: 'See the list of available data',
    numberData: 'Number of data: ',
    numberPrompts: 'Results',
    validate: 'Validate',
    reset: 'Reset',
    cancel: 'Cancel',
    formTitle: 'Title',
    formTon: 'Tone',
    formReference: 'Reference',
    formDonnees: 'Data',
    formPrompt: 'Prompt',
    selectedTon: 'Select your tone',
    selectedPrompt: 'Instruction selection',
    confirmDeleted: 'Are you sure you want to delete this prompt?',
    resetPromptDialog: 'Are you sure you want to reset this prompt?',
    infoRecordingPrompt: 'Your prompt "{{title}}" will be recorded in your library. ',
    infoRecordingPostPrompt: 'You can then select it to generate a post',
    infoUpdatingPrompt: 'Your prompt "{{title}}" will be edited in your library.',
    infoDeletingPrompt: 'Your prompt "{{title}}" will be deleted from your library',
    infoResetPrompt: 'Are you sure you want to reset your prompt?',
    recordSuccess: 'Your prompt has been saved in your library',
    recordFailed: 'Your prompt could not be recorded in your library',
    updatedSuccess: 'Your prompt was successfully modified in your library',
    updatedFailed: 'Your prompt could not be modified in your library',
    deletedSuccess: 'Your prompt has been deleted from your library',
    deletedFailed: 'Your prompt could not be deleted from your library',
    selectedFailed: 'Your prompt was not selected in your library',
    newPrompt: 'New prompt',
    addNewPrompt: 'Create a new prompt',
    placeholderPrompt: 'In addition to the above, please specify your writing instructions for what you want to appear on your posts, such as the number of emoticons or #s',
    rulesTitle: 'Please enter a title',
    rulesLength: 'The minimum length is 3 characters',
    rulesTon: 'Please enter a tone',
    rulesDonnees: 'Please enter at least one piece of data',
    rulesPrompt: 'Please enter elements in the prompt',
    contentTitleTooltip: 'The title of your instruction will not be made public. It will help you find it more easily when creating your posts',
    contentTonTooltip: 'Selected the tone in which you want your instruction to be written by our Artificial Intelligence from the drop-down list',
    contentDonneesTooltip: 'Selected the data from your adverts that you would like our Artificial Intelligence to use to create your posts',
    contentReferenceTooltip: 'You can choose to display the reference of your ad in your post',
    contentDonneesTooltipList: 'You can expand your selection using the field provided or the full list of data available from the link below.',
    contentPromptTooltip: 'Write your prompt to provide our Artificial Intelligence with your instructions and generate the text creation',
    postUpdated: 'Your ad has been updated',
    selected: 'Selection',
    instructionPromptByDefault: 'Select your default instruction',
    selectedPromptIAGenerated: 'Are you sure you want to select this prompt to generate an AI post?'
  }
}
